'use client';

export const trackEvent = (eventName, params, clearEcommerce = false) => {
  window.dataLayer = window.dataLayer || [];
  if (clearEcommerce) {
    window.dataLayer.push({ ecommerce: null });
  }
  window.dataLayer.push({
    event: eventName,
    ...params,
  });
};
